import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import BuscadorColegios from "./inscripciones/BuscadorColegios";
import { Container } from "semantic-ui-react";
import { inscripcionesOps } from "../ducks/inscripciones";
import { escuelasOps } from "../ducks/escuelas";
import { documentacionOps } from "../ducks/documentacion";
import TablaEscuelas from "./inscripciones/TablaEscuelas";
import { Transition, Segment, Header } from "semantic-ui-react";

class Inscripciones extends React.Component {
  state = {
    redirect: false,
    redirectTo: null,
    mostrarTabla: false,
    mostrarTablaDocumentos: false,
    visible: false
  };

  componentDidMount() {
    this.props.obtenerSearchDataInscripciones();
    this.props.obtenerListaColegiosConEscuelas();
    this.setState(state => ({ visible: true }));
  }

  componentWillUnmount() {
    this.props.detachEscuelasListeners();
    this.props.limpiarListaColegioEscuelas();
  }

  handleInscribirEnColegio = (name, { busqueda }) => {
    this.props.inscribirEnColegio(busqueda);
    this.setState({
      redirect: true,
      redirectTo: <Redirect to="/hojainscripcion" />,
      mostrarTabla: false
    });
  };

  handleMostrarTodos = () => {
    this.setState({ mostrarTabla: true, mostrarTablaDocumentos: false });
  };

  handleAdjuntarDoc = () => {
    this.setState(state => ({
      mostrarTabla: false,
      mostrarTablaDocumentos: true
    }));
  };

  handleRowClick = opcion => idColegio => {
    if (opcion === "inscripcion") {
      this.props.limpiarColegioSeleccionado();
      this.props.inscribirEnColegio(idColegio);
      this.setState({
        redirect: true,
        redirectTo: <Redirect to="/hojainscripcion" />,
        mostrarTabla: false,
        mostrarTablaDocumentos: true
      });
    } else {
      this.props.resetInscribirEnColegio();
      this.props.documentacionAColegio(idColegio);
      this.setState({
        redirect: true,
        redirectTo: <Redirect to="/adjuntar-documentacion" />,
        mostrarTabla: false,
        mostrarTablaDocumentos: true
      });
    }
  };

  render() {
    return this.state.redirect ? (
      this.state.redirectTo
    ) : (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <BuscadorColegios
              searchData={this.props.searchListaColegios}
              handleInscribirEnColegio={this.handleInscribirEnColegio}
              handleMostrarTodos={this.handleMostrarTodos}
              handleAdjuntarDoc={this.handleAdjuntarDoc}
            />
            {this.state.mostrarTabla && (
              <Segment>
                <Header as="h3">
                  Seleccione el Colegio en el que quiere realizar la inscripción
                </Header>
                <TablaEscuelas
                  datos={this.props.listaColegiosEscuelas}
                  handleRowClick={this.handleRowClick("inscripcion")}
                />
              </Segment>
            )}
            {this.state.mostrarTablaDocumentos && (
              <Segment>
                <Header as="h3">
                  Seleccione el Colegio en el que ha realizado la inscripción.
                </Header>
                <Header as="h4">
                  Tenga a mano el número de resguardo.
                </Header>
                <TablaEscuelas
                  datos={this.props.listaColegiosEscuelas}
                  handleRowClick={this.handleRowClick("documentacion")}
                />
              </Segment>
            )}
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  searchListaColegios: state.inscripciones.searchListaColegios,
  listaColegiosEscuelas: state.escuelas.listaColegiosEscuelas
});

const mapDispatchToProps = {
  obtenerSearchDataInscripciones:
    inscripcionesOps.obtenerSearchDataInscripciones,
  limpiarListaColegioEscuelas: escuelasOps.limpiarListaColegioEscuelas,
  obtenerListaColegiosConEscuelas: escuelasOps.obtenerListaColegiosConEscuelas,
  detachEscuelasListeners: escuelasOps.detachEscuelasListeners,
  inscribirEnColegio: inscripcionesOps.inscribirEnColegio,
  resetInscribirEnColegio: inscripcionesOps.resetInscribirEnColegio,
  documentacionAColegio: documentacionOps.documentacionAColegio,
  limpiarColegioSeleccionado: documentacionOps.limpiarColegioSeleccionado
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Inscripciones);



// WEBPACK FOOTER //
// ./src/pages/Inscripciones.jsx